import React, { useState, useRef, useEffect, useCallback } from "react";
import styled from "styled-components";
import QuillOne from "../../../components/organisms/Quill";
import TabModal from "../../../components/molecules/TabModal";
import Preview from "../../../components/organisms/Preview";
import agent from "../../../agent";
import { inject, observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import TagList from "../../../data/TagList";
import LogInfo from "../../../components/atoms/LogInfo";
import ImageGeneratorBoard from "../../../components/organisms/ImageGeneratorBoard";
import axios from "axios";
import ImageDirectGeneratorBoard from "../../../components/organisms/ImageDirectGeneratorBoard";

/** 글 작성하기(칼럼 쓰기) */
const ComposeTemplate = inject("commonStore")(
  observer((props) => {
    const history = useHistory();
    const [disBox, setDisBox] = useState("none"); // 모달 유무 state
    const [contValue, setContValue] = useState(""); // 본문 onChange
    const [filterTag, setFilterTag] = useState([]); //태그리스트 state
    const [tags, setTags] = useState(TagList); //태그 변환 state
    const [title, setTitle] = useState(""); //제목 state
    const [cost, setCost] = useState(0); // 유료칼럼일 경우 포인트 소모 비용
    const mainKwRef = useRef(); //메인 키워드 ref
    const relKwRef = useRef(); //관련 키워드 ref
    const subSelRef = useRef(); // 부종류 ref
    const quillRef = useRef(); // 본문 ref
    const [count, setCount] = useState(""); //본문 길이 state
    const [err, setErr] = useState({
      mainKw: "", //메인 키워드
      relKw: "", //관련 키워드
      title: "", //제목
      sub: "", //요약본
      content: "", // 본문
      tags: "", //태그
      cost: "", //포인트비용
    });

    const [generatedImageData, setGeneratedImageData] = useState(null); // 생성한 이미지 태그

    const [imgUploading, setImgUploading] = useState(false); //이미지 업로드중
    const fileInputRef = useRef(); //이미지 업로드 ref

    /** 멀티이미지 업로드 */
    const onUploadImages = (e) => {
      const testAPI = "https://okr.luvd.co.kr/api";
      setImgUploading(true);
      //이미지 업로드
      const { files } = e.target;
      console.log("files", files);
      console.log("props.commonStore.token", props.commonStore.token);
      const formData = new FormData();

      // 파일이름 랜덤하게 변경하여 배열과 폼데이터에 저장
      const fileNames = [];
      for (let i = 0; i < files.length; i++) {
        const formatIdx = files[i].name.lastIndexOf(".");
        const format = files[i].name.substring(formatIdx);
        const newFileName = `${Math.floor(Math.random() * 3000)}_${new Date().getTime()}${format}`;
        formData.append("column_image", files[i], newFileName);
        fileNames.push(newFileName);
      }

      // FormData의 key 확인
      for (let key of formData.keys()) {
        console.log(key);
      }

      // FormData의 value 확인
      for (let value of formData.values()) {
        console.log(value);
      }
      axios
        .post(`${testAPI}/column/images`, formData, {
          headers: {
            ContentType: "multipart/form-data",
            Authorization: `Bearer ${props.commonStore.token}`,
          },
        })
        .then((res) => {
          console.log(res);
          // quill 에디터 html내용에 이미지 태그 추가
          let imageTags = "";
          const editor = quillRef.current.getEditor();
          fileNames.forEach((fileName) => {
            imageTags += `<p><img src="${testAPI}/common/image/${fileName}"></p>`;
            // const range = editor.getSelection();
            // editor.insertEmbed(
            //   range.index ?? editor.getLength() ?? 0,
            //   "image",
            //   `${testAPI}/common/image/${fileName}`
            // );
          });
          const originalInnerHTML = quillRef.current.state.value;
          editor.root.innerHTML = originalInnerHTML + imageTags;
          console.log("quillRef.current.state.value", quillRef.current.state.value);
          console.log("editor.root.innerHTML", editor.root.innerHTML);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setImgUploading(false);
        });
    };

    const GeneratedImageHandler = (data) => {
      console.log("부모가 받은 값:", data);

      if (Array.isArray(data) && data.length) {
        let imageTagData = data.map((item, index) => {
          console.log("파일이름:", item.image_name);
          console.log("인덱스:", item.image_index);
          console.log("스니펫:", item.paragraphSnippet);
          console.log("문단번호:", item.paragraphNumber);

          return {
            imageTag: `<img src="https://okr.luvd.co.kr/api/common/image/${item.image_name}" alt="generated" />`,
            imageName: item.image_name,
            imageIndex: item.image_index,
            paragraphSnippet: item.paragraphSnippet,
            paragraphNumber: item.paragraphNumber,
          };
        });
        setGeneratedImageData(imageTagData); // 생성한 값을 useState 변수에 저장
        // console.log("imageTagData", imageTagData); // 확인용 출력
        alert("선택사항이 저장되었습니다.");
      } else {
        console.error("입력받은 값이 없습니다.");
      }
    };

    useEffect(() => {
      //todo check
      for (let d of mainKwRef.current.value.split(" ")) {
        if (d !== "" && title.includes(d)) {
          props.commonStore.setTodo(1, 0); // 제목 키워드가 들어가면 할 일 목록 on
        } else {
          props.commonStore.setTodo(2, 0);
        }
      }

      if (filterTag.length !== 0) {
        props.commonStore.setTodo(1, 6);
      } else {
        props.commonStore.setTodo(2, 6);
      }
    });

    const findHTags = useCallback(() => {
      const qlEditor = document.querySelector(".ql-editor");
      const h2Length = qlEditor?.querySelectorAll("h2").length;
      const h3Length = qlEditor?.querySelectorAll("h3").length;
      const h4Length = qlEditor?.querySelectorAll("h4").length;
      return h2Length + h3Length + h4Length;
    }, []);

    useEffect(() => {
      props.commonStore.setHTagCount(findHTags());
    }, [contValue, findHTags, props.commonStore]);

    const goToList = () => {
      history.push("/main");
      props.commonStore.setTodo(3, 3); //할 일 목록 초기화
    };
    const mainKwValid = () => {
      //메인 키워드 타이핑 valid 반응
      for (let d of mainKwRef.current.value.split(" ")) {
        if (d !== "" && title.includes(d)) {
          props.commonStore.setTodo(1, 0); // 제목 키워드가 들어가면 할 일 목록 on
        } else {
          props.commonStore.setTodo(2, 0);
        }

        if (d !== "" && contValue.split(d).length - 1 > 1) {
          props.commonStore.setTodo(1, 1); // 본문에 키워드가 2개 이상이면 할 일 목록 on
        } else {
          props.commonStore.setTodo(2, 1);
        }
      }
    };
    const [mode, setMode] = useState({
      //모달 종류
      tag: false, // 태그 모달
    });
    const [sel, setSel] = useState("기사"); //기사, 칼럼 state

    // 글종류 선택 변경시
    const changeHandler = (e) => {
      setSel(e.target.value);
    };
    const openModal = () => {
      setDisBox("flex");
      setMode({ tag: true });
      for (let j of tags) {
        // 선택된 태크 자동 선택
        if (filterTag.includes(j.cont)) {
          setTags([...tags]);
          j.checked = true;
          j.background = "#1D83E9";
          j.color = "white";
        }
      }
    };

    const Base64toServerImage = (fullstring, name) => {
      //img src 길이 축소하기
      const changeStr = fullstring
        .split('<img src="data')
        .map((v, i) => {
          if (v.includes("base64")) {
            return `<img src="${name[i - 1]}">${v.split(v.includes('=">') ? '=">' : v.includes('C">') ? 'C">' : 'Z">')[1]}`; //base64 끝자리 기준으로 분리하서 값 변환
          } else if (v.includes("src")) {
            if ([...v][0] === "<") {
              // 첫 글자가 src로 시작안하면 그냥 값 변환, 아니면 <img 붙이기
              return v;
            } else {
              return `<img${v}`;
            }
          } else {
            return v;
          }
        })
        .filter((v) => v !== false)
        .join("");
      return changeStr;
    };

    const testAPI = "https://okr.luvd.co.kr/api";
    const searchSrc = (root) => {
      //img src
      const arr1 = root
        .split("<img")
        .map((v) => {
          return v.includes("base64") ? v : false;
        })
        .filter((v) => v !== false);
      return arr1.map((v) => {
        return v.split('">')[0];
      });
    };

    const DataURIToBlob = (dataURI) => {
      // 이미지 코드 base64로 저장하면 로딩이 너무 길어져서 인코딩해서 변환
      const process2 = dataURI.map((v) => {
        let splitDataURI = v.split(",");
        const nameMaking = `${Math.floor(Math.random() * 3000)}_${new Date().getTime()}`;
        const byteString = splitDataURI[0].indexOf("base64") >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]); //base64 뒤 코드
        const mimeString = v.split(":")[1].split(";")[0]; //image/*
        const ia = new Uint8Array(byteString.length);
        for (let j = 0; j < byteString.length; j++) {
          ia[j] = byteString.charCodeAt(j);
        }
        return {
          blob: new Blob([ia], { type: mimeString }),
          name: `${testAPI}/common/image/${nameMaking}.${mimeString.split("/")[1]}`,
        };
      });
      return process2;
    };

    const titleChange = (e) => {
      //제목 입력할 때
      setTitle(e.target.value);
    };

    const submitHandler = async (ver) => {
      // 칼럼 제출할 때
      if (ver !== 1) {
        //임시저장이 아닐 때 todo 체크
        if (cost < 0) {
          setErr({ cost: "• 포인트비용은 음수가 될 수 없습니다." });
        }
        if (mainKwRef.current.value === "") {
          setErr({ mainKw: "• 메인 키워드를 입력하지 않았습니다." });
          return;
        }
        if (title === "") {
          setErr({ title: "• 제목을 입력해주세요!" });
          return;
        }
        for (let d of mainKwRef.current.value.split(" ")) {
          //띄어쓰기 해도 메인키워드 인식 할 수 있게 함
          if (!title.includes(d)) {
            setErr({ title: "• 제목에 메인키워드가 포함되지 않았습니다!" });
            return;
          }
        }
        if (quillRef.current.editingArea.textContent === "") {
          setErr({ content: "• 본문이 비어있습니다." });
          return;
        }
        if (quillRef.current.editingArea.textContent.length < 1500) {
          setErr({ content: "• 본문 글자 제한은 1500자 이상입니다." });
          return;
        }
        if (contValue.split(mainKwRef.current.value).length - 1 < 2) {
          setErr({ content: "• 본문에 키워드가 2회 이상 들어가야합니다." });
          return;
        }
        if (contValue.split("<img").length - 1 < 2) {
          setErr({ content: "• 이미지는 2장 이상 올려주세요." });
          return;
        }
        if (contValue.split("<a").length - 1 < 2) {
          setErr({ content: "• 링크는 2개 이상 올려주세요." });
          return;
        }
        if (props.commonStore.hTagCount < 2) {
          setErr({
            content: "• 소제목은 2개 이상 등록해주세요. 소제목으로 하려는 텍스트를 드래그하고 heading을 클릭해주세요.",
          });
          return;
        }
        if (filterTag.length === 0) {
          setErr({ tags: "• 태그를 추가해주세요!" });
          return;
        }
      }

      const imgBase64 = searchSrc(quillRef.current.state.value);
      const file = DataURIToBlob(imgBase64);
      const formData = new FormData();
      // const innerHTML = Base64toServerImage(quillRef.current.state.value, file.map(v=>v.name)) // 기존 코드
      let innerHTML = Base64toServerImage(
        quillRef.current.state.value,
        file.map((v) => v.name)
      ); // 생성한 이미지 삽입을 위한 코드

      // 이미지 생성 후 선택한 이미지 값이 있다면
      // 입력한 html을 파싱해서 문단 앞에 붙이기
      if (generatedImageData) {
        // innerHTML = innerHTML + generatedImageTag // 맨 뒤에 붙이는 확인용 코드
        console.log("generatedImageData", generatedImageData);

        generatedImageData.forEach((data) => {
          const { imageTag, paragraphSnippet } = data;
          const paragraphIndex = innerHTML.indexOf(paragraphSnippet);

          if (paragraphIndex !== -1) {
            // paragraphSnippet가 발견되면, 그 위치에 imageTag를 삽입
            innerHTML = innerHTML.slice(0, paragraphIndex) + imageTag + innerHTML.slice(paragraphIndex);
          } else {
            console.log("paragraphSnippet를 innerHTML에서 찾을 수 없습니다.");
          }
        });
      }

      // 이미지태그 처리후 에디터 innerHTML 변경
      console.log("innerHTML", innerHTML);
      const editor = quillRef.current.getEditor();
      console.log("editor.root", editor.root);
      editor.root.innerHTML = innerHTML; // 이미지 에디터

      // 맨 마지막에 개행 2번 추가
      let tailString = "<p><br></p><p><br></p>";

      // 글을 저장하기 위한 오브젝트
      let dataObject = {
        category: sel,
        sub_category: subSelRef.current.value, // 글 종류
        main_keyword: mainKwRef.current.value,
        writer_id: localStorage.getItem("writer_id"),
        writer: localStorage.getItem("name"),
        title: title === "" ? "임시저장한 게시물입니다." : title,
        subTitle: quillRef.current.editingArea.textContent.substr(0, 32),
        content: innerHTML.endsWith(tailString) ? innerHTML : innerHTML + tailString, // 기존값 : innerHTML
        state: ver === 1 ? 1 : 2,
        column_keyword: [relKwRef.current.value].map((v, i) => {
          return {
            order: i,
            name: v,
          };
        }),
        column_tag: filterTag.map((v, i) => {
          return {
            order: i,
            name: v,
          };
        }),
        cost: cost,
      };

      // 입력받은 칼럼 데이터를 서버로 전송
      formData.append("column", JSON.stringify(dataObject)); // formDate 객체에 작성한 데이터를 Json으로 저장

      // 배열 안의 파일 정보 순회하며 각 데이터에 대한 처리 진행
      for (let i in file) {
        console.log(file[i].name);
        await formData.append("column_image", file[i].blob, file[i].name); //3번째는 filename
      }
      agent.Column.create(formData) // 칼럼 작성 api 호출
        .then(async (res) => {
          await props.commonStore.getAllPage(1).then((res) => {
            if (ver === 1) {
              //임시저장이면 방금 생성한 게시물로 이동
              alert("임시저장 완료!");
              history.push(`/detail/${res[0].id}`);
            }
          });

          if (ver === 2) {
            //제출이면 리스트로 이동
            alert("칼럼 생성 완료!");
            //main은 칼럼 리스트 페이지
            history.push("/main");
          }
        })
        .catch((err) => {
          console.log(dataObject);
          if (err.response.statusCode === 401) {
            history.push("/");
          }
        });
    };
    return (
      <Box id="container">
        {imgUploading && (
          <Loading>
            <div className="content">
              <div className="spinner"></div>
              <h3>이미지 업로드 중</h3>
            </div>
          </Loading>
        )}
        <div>
          <div>
            <h1>칼럼 쓰기</h1>

            <div>
              <LogInfo />
              <div>
                <div onClick={goToList} style={{ cursor: "pointer" }}>
                  리스트
                </div>
              </div>
            </div>
          </div>
          <TabModal
            disBox={disBox}
            setDisBox={setDisBox}
            filterTag={filterTag}
            mode={mode}
            setMode={setMode}
            setFilterTag={setFilterTag}
            tags={tags}
            setTags={setTags}
          />
          <div>
            <div className="box write">
              <div className="inputs_row">
                <span>
                  <span className="label">메인키워드</span>
                  <div>
                    <input type="text" ref={mainKwRef} onKeyUp={mainKwValid} placeholder="칼럼의 메인 키워드를 입력해주세요" />
                    <Err>{err.mainKw}</Err>
                  </div>
                </span>
                <span>
                  <span>관련 키워드</span>
                  <div>
                    <input type="text" ref={relKwRef} placeholder="메인키워드와 관련된 키워드를 입력해주세요" />
                    <Err>{err.relKw}</Err>
                  </div>
                </span>
              </div>
              <div className="type">
                <span>글 종류</span>
                <select value={sel} onChange={changeHandler}>
                  <option>기사</option>
                  <option>칼럼</option>
                </select>
                <span className="line">|</span>
                <select ref={subSelRef}>
                  {sel === "기사" ? (
                    <>
                      <option>리데</option>
                      <option>포데</option>
                    </>
                  ) : (
                    <>
                      <option>재회</option>
                      <option>싱글</option>
                      <option>커플</option>
                      <option>relove</option>
                      <option>reuniondate</option>
                      <option>reunionlove</option>
                    </>
                  )}
                </select>
              </div>
              <div className="inputs_row">
                <span>
                  <span className="label">포인트비용</span>
                  <div>
                    <input
                      type="number"
                      value={cost}
                      onChange={(e) => {
                        setCost(e.target.value);
                      }}
                      min={0}
                      className="number_input"
                    />
                    <span className="extra">*0일경우 무료</span>
                    <Err>{err.cost}</Err>
                  </div>
                </span>
              </div>
              <div className="inputs">
                <span style={{ marginRight: "75px" }}>제목</span>
                <div>
                  <input type="text" value={title} onChange={titleChange} placeholder="메인키워드가 포함된 제목을 적어주세요" />
                  <Err>{err.title}</Err>
                </div>
              </div>
              <div className="images_upload">
                <div>
                  <label htmlFor="files">멀티이미지 업로드</label>
                  <input id="files" type="file" accept="image/*" ref={fileInputRef} onChange={onUploadImages} multiple />
                </div>
              </div>
              <QuillOne
                contValue={contValue}
                setContValue={setContValue}
                err={err}
                quillRef={quillRef}
                count={count}
                setCount={setCount}
                mainKw={mainKwRef}
                hCount={props.commonStore.hTagCount}
              />
              <div className="tags">
                <span>태그</span>
                <div>
                  <span>
                    <span className="tag_box">
                      {filterTag.map((v, i) => {
                        return <span key={i}>{v}</span>;
                      })}
                    </span>
                    <span onClick={openModal}>+ 태그 추가</span>
                  </span>
                  <Err>{err.tags}</Err>
                </div>
              </div>
              <div>
                <span onClick={() => submitHandler(1)}>임시저장</span>
                <span onClick={() => submitHandler(2)}>제출하기</span>
              </div>
            </div>
            <Preview contValue={contValue} count={count} />
          </div>
        </div>

        <ImageGeneratorBoard contValue={contValue} setContValue={setContValue} GeneratedImageHandler={GeneratedImageHandler} count={count} />
        <ImageDirectGeneratorBoard />
      </Box>
    );
  })
);

const Loading = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  .content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    > h3 {
      margin-top: 10px;
    }
    .spinner {
      min-width: 30px;
      min-height: 30px;
      border: 5px solid rgba(255, 255, 255, 0.1);
      border-right: 5px solid skyblue;
      border-radius: 50%;
      animation: spinner 1s linear infinite;
    }
    @keyframes spinner {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  }
`;

const Box = styled.div`
  padding: 30px;
  box-sizing: border-box;
  overflow: auto;
  height: 100vh;

  .images_upload {
    label {
      display: inline-block;
      padding: 0.5em 0.75em;
      color: #505050;
      font-size: inherit;
      line-height: normal;
      vertical-align: middle;
      background-color: #fdfdfd;
      cursor: pointer;
      border: 1px solid #ebebeb;
      border-bottom-color: #e2e2e2;
      border-radius: 0.25em;
    }

    input[type="file"] {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
    }
  }

  .extra {
    font-size: 12px;
    margin-left: 10px;
  }
  .box {
    padding-top: 20px;
  }

  @media (max-width: 1250px) {
    & > div > div:last-child > .preview {
      display: none !important;
    }

    & > div > div:last-child > .write {
      width: 100% !important;
      margin-right: 0px !important;
    }
  }
  & > div {
    > div:first-child {
      display: flex;
      align-items: center;
      justify-content: space-between;

      > h1 {
        font-size: 20px;
        font-weight: 700;
      }
      > div {
        display: flex;
        > div:last-child {
          color: white;
          background: #43425d;
          box-sizing: border-box;
          padding: 10px 20px;
          border-radius: 4px;
          font-size: 13px;
          margin-left: 20px;
        }
      }
    }

    > div:last-child {
      display: flex;
      margin-top: 19px;

      > .write,
      > .preview {
        height: 810px;
      }

      > .write {
        width: 70%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-right: 20px;

        > div {
          margin-bottom: 10px;
        }

        > .inputs_row {
          width: 100%;
          display: flex;
          justify-content: space-between;

          > span {
            width: 50%;
            display: flex;
            align-items: center;

            > span {
              margin-right: 30px;
            }
            > div {
              width: 70%;

              > input {
                width: 100%;
                border: 1px solid #e8e9ec;
                box-sizing: border-box;
                padding: 10px 20px;
                border-radius: 4px;
                font-size: 13px;
              }
              .number_input {
                width: 70px;
              }
            }
          }
        }

        > .type {
          width: 100%;

          > span:first-child {
            margin-right: 56px;
          }

          > select {
            border: 1px solid #e8e9ec;
            width: 15%;
            box-sizing: border-box;
            padding: 10px;
            border-radius: 4px;
            font-size: 13px;
          }

          > .line {
            margin: 0 18px;
          }
        }

        > .inputs {
          width: 100%;
          display: flex;

          > div {
            width: 85.5%;

            > input,
            textarea {
              width: 100%;
              border: 1px solid #e8e9ec;
              box-sizing: border-box;
              padding: 10px 20px;
              border-radius: 4px;
              font: 13px "Noto Sans";
              resize: none;
            }
          }
        }

        > .tags {
          width: 100%;
          margin-top: 10px;
          display: flex;

          > span:first-child {
            margin-right: 75px;
          }

          > div {
            width: 85.5%;

            > span {
              width: 100%;
              display: flex;
              margin-bottom: 10px;
              justify-content: space-between;

              > .tag_box {
                > span {
                  background: #ededed;
                  border-radius: 8px;
                  box-sizing: border-box;
                  padding: 2px 10px;
                  margin-right: 5px;
                }
              }

              > span:last-child {
                color: #868686;
                cursor: pointer;
              }
            }
          }
        }
        > div:last-child {
          width: 94%;
          margin-top: 30px;
          display: flex;
          justify-content: flex-end;

          > span {
            box-sizing: border-box;
            border-radius: 4px;
            padding: 10px;
            margin-left: 5px;
            cursor: pointer;
          }

          > span:first-child {
            border: 1px solid #42415c;
          }

          > span:last-child {
            background: #42415c;
            color: white;
          }
        }
      }

      > .preview {
        width: 30%;
        display: flex;
      }
    }
  }
`;

const Err = styled.p`
  color: #f43419;
  line-height: 1.5;
  font-size: 14px;
  margin-left: 3px;
`;

export default ComposeTemplate;
